export default __webpack_public_path__ + "static/heart-pattern-tessellate-maroon-011ba044fd1c20af95f8fc8a9eced6df.jpg";